import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { getLiveKitJoinUrl } from "./livekit_utils";
import "./livekit_component.scss";

const LiveKit = ({ userData }) => {
  const { meetingId } = useParams();
  const location = useLocation();
  const queryUserId = new URLSearchParams(location.search).get("user_id");

  useEffect(() => {
    if (window.clarity) {
      window.clarity("stop");
    }
  }, []);

  useEffect(() => {
    if (!meetingId) return;
    const userId = queryUserId || userData?.user_id || "";
    window.location.replace(getLiveKitJoinUrl(meetingId, userId));
  }, [meetingId, queryUserId, userData]);

  return (
    <div className="livekit-meeting-container" data-clarity-mask="true">
      <div className="livekit-loading-container">
        <h2>Loading class...</h2>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth.user,
});

export default connect(mapStateToProps)(LiveKit);
